import * as x from '../helpers/xmlHelpers';

export class ForeignObject {
    constructor(doc)
    {
		this.label = null;
		this.objectURL = null;
		this.mIMETypeIdentifier = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.objectURL = x.getStringElement(doc, "./ns:ObjectURL");
		this.mIMETypeIdentifier = x.getStringElement(doc, "./ns:MIMETypeIdentifier");
   }
}

export class ViewFile {
    constructor(doc)
    {
		this.label = null;
		this.foreignObject = null;
		var node;

		this.label = x.getStringAttribute(doc,"xlink:label");
		node = x.selectSingleNode(doc, "./ns:FOREIGN_OBJECT");
		if (node !== null)
				this.foreignObject = new ForeignObject(node);
   }
}

export class View {
    constructor(doc)
    {
		this.label = null;
		this.viewFiles = [];
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		nodes = x.selectNodes(doc, "./ns:VIEW_FILES/ns:VIEW_FILE");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.viewFiles.push(new ViewFile(xn));
			});
		}
   }
}

